<div class="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
  <div class="text-center p-5 bg-white rounded shadow-sm" style="max-width: 480px; width: 100%;">
    <h4 class="fw-semibold mb-3" style="color: #374151;">Sistema en mantenimiento</h4>
    <p class="text-muted mb-4">
      El sistema está en mantenimiento temporal.<br>
      Por favor, volvé en unos minutos.
    </p>
    <button class="btn btn-outline-secondary btn-sm" (click)="reload()">Reintentar</button>
  </div>
</div>
